import React, { useEffect, useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';
import Box from '@mui/material/Box';
import Button from "@mui/material/Button";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';
import { ListingDetailDialog } from '../ListingDetail/dialog';
import './styles.css';

// Horizontal, scrollable row of selectable accommodation cards. The whole
// CardActionArea is the hit target (fixed a prior checkpoint — preserved here).
// Appearance standardized to the app card pattern: theme radius, the standardized
// LocationOnRounded pin, tokenized text, dark-mode-safe.
const HorizontalSelectableCards = ({ title, list, handleClick, selected, disabled }) => {
  const [open, setOpen] = useState(false);
  const [serviceProvider, setServiceProvider] = useState(null);
  const [isAdded, setIsAdded] = useState('');
  const hasItems = list && list.length > 0;

  const handleClose = () => {
    setOpen(false);
  };

  const handleClickOpen = (data) => {
    console.log("click data:: ", data)
    setServiceProvider(data)
    setOpen(true);
  };

  useEffect(() => {
    if (selected) {
      console.log("Selected: ", selected)
      setIsAdded(selected)
    } else {
      console.log("Not Selected: ", selected)

    }
  }, [selected])
  return (
    <Box>
      <Typography sx={{ marginLeft: '1em', fontSize: '1em' }} component="h2" className='txt--sub-heading'>
        {title}
      </Typography>
      <div className="itinerary">
        {hasItems ? (
          list.map((item, index) => (
            <Card
              key={`${item.images?.[0] || 'img'}-${index}`}
              className='itinerary-card'
              sx={{ width: 'auto', maxWidth: '160px', borderRadius: 2, marginBottom: '12px' }}
            >
              <CardActionArea component="div">
                <CardMedia
                  component="img"
                  height="160px"
                  sx={{ width: '100%', maxHeight: '10em', height: '45vw' }}
                  image={item.images?.[0] || ''}
                  alt={item.name}
                  onClick={() => handleClickOpen(item)}
                />
                <CardContent sx={{ px: 1.5, py: 1 }}>
                  <Typography
                    component="div"
                    sx={{ fontSize: '.8em', lineHeight: '1.1em', display: 'flex', alignItems: 'center', color: 'text.primary' }}
                  >
                    <LocationOnRoundedIcon sx={{ fontSize: '1rem', mr: 0.5, color: 'text.secondary', flexShrink: 0 }} />
                    {item.name}
                  </Typography>
                  <br />
                  <Button
                    variant="text"
                    disabled={disabled}
                    onClick={() => handleClick(item)}
                    startIcon={isAdded === item.name ? <CheckRoundedIcon /> : <AddCircleRoundedIcon />}
                  >
                    {isAdded === item.name ? 'Selected' : 'Select'}
                  </Button>
                </CardContent>
              </CardActionArea>
            </Card>
          ))
        ) : (
          <Typography color="text.secondary" sx={{ px: 2, py: 2, fontSize: '.9em' }}>
            No options available.
          </Typography>
        )}
      </div>
      {/* Stays a modal on purpose. This row is the itinerary builder's picker,
          so routing to /listing/:id would take the traveller out of the flow
          and discard the selection they are part-way through making. Everywhere
          else links to the route. */}
      <ListingDetailDialog open={open} handleClose={handleClose} listing={serviceProvider} />

    </Box>
  );
};

export default HorizontalSelectableCards;
